import React, { useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import JiraSecurityToolConfiLoginForm from "./JiraSecurityToolConfiLoginForm";
import JiraSecurityToolMappingForm from "./JiraSecurityToolMappingForm";
import { JiraSecurityToolRecordProps } from "./JiraSecurityToolPropTypes";

// add more props types as required
type JiraSecurityToolConfigListingProps = {
  record?: JiraSecurityToolRecordProps;
  name?: string;
};

function JiraSecurityToolConfigListing(
  props: JiraSecurityToolConfigListingProps,
) {
  const columns = useMemo(
    () => [
      {
        title: "Project Key",
        dataIndex: "projectKey",
        width: 240,
        render: CellRenderers.VALUE_OR_NA,
      },
      {
        title: "Issue Type",
        dataIndex: "issueType",
        width: 240,
        render: CellRenderers.VALUE_OR_NA,
      },
    ],
    [],
  );

  return (
    // @ts-expect-error
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={JiraSecurityToolMappingForm}
      CredentialsForm={JiraSecurityToolConfiLoginForm}
      extraColumns={columns}
    />
  );
}

export default JiraSecurityToolConfigListing;
